import useModal from "@/@core/components/base-modal/hooks/useModal";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import inventoryPrivilegeFormModel from "@/models/inventory/inventory-privilege-form";
import { privilegeInfoModel } from "@/models/privilege/privilege-form";
import router from "@/router";
import store from "@/store";
import useFlatPickr from "@/utils/hooks/useFlatPickr";
import useLoadingDefault from "@/views/components/loading/hooks/useLoading";
import { getCurrentInstance, reactive, ref, watch } from "@vue/composition-api";
import { PRIVILEGE_TYPE } from "@/configs/privilege/privilege";

export default function usePrivilegeInformation(props) {
  const {
    createForm,
    editForm,
    fetchDetail,
    fetchStoreList,
  } = privilegeInfoModel();
  const { fetchAssignEntryInventory } = inventoryPrivilegeFormModel();
  const { loading } = useLoadingDefault();
  const { openModal, closeModal } = useModal();
  const {
    openErrorModal,
    openSuccessModal,
    openWarningModal,
    openDefaultErrorModal,
  } = useValidationModal();
  const {
    flatpickrDateConfig,
    flatpickrTimeConfig,
    resolveDateString,
    resolveDate,
    resolveTime,
    resolveDateObject,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
  } = useFlatPickr();

  const vm = getCurrentInstance().proxy;

  const isEditData = ref(false);
  const privilegeSelect = ref({
    inventory_entry: [],
  });

  const modalType = reactive({
    assignInventory: false,
    chooseStore: false,
  });

  const formData = reactive({
    privilegeId: 0,
    isActive: false,
    reference: null,
    privilegeType: PRIVILEGE_TYPE.REWARD,
    nameEn: "",
    nameTh: "",
    subNameEn: "",
    subNameTh: "",
    detailEn: "",
    detailTh: "",
    ruleTh: "",
    ruleEn: "",
    RedeemLimit: 1,
    RedeemMode: 1,
    ExpirationMode: 1,
    ExpYear: null,
    ExpMonth: null,
    ExpDay: null,
    ExpHour: null,
    ExpMinute: null,
    IssueOverall: null,
    IssuePerDay: null,
    IssuePerMonth: null,
    IssuePerCustomer: null,
    IssuePerCustomerDay: null,
    IssuePerCustomerMonth: null,
    RedeemOverall: null,
    RedeemDay: null,
    RedeemMonth: null,
    RedeemCustomer: null,
    RedeemCustomerDay: null,
    RedeemCustomerMonth: null,
    ValueReference: null,
    pointRef: null,
    ReserveTimeOut: null,
    couponCodeType: 5,
    redeemPerMin: "1",
    validFrom: { date: null, time: null },
    validThrough: { date: null, time: null },
    fixedDate: { date: null, time: null },
    ExpRoundingMode: 1,
    assignInventoryList: [],
    storeMapping: [],
    ExchangeId: 0,
    ExchangeStepValue: 0,
    ExchangeMinValue: 0,
  });

  const optionData = reactive({
    privilegeType: [
      { label: "Reward/Privilege (RP)", value: PRIVILEGE_TYPE.REWARD },
      { label: "Coupon Code (CPC)", value: PRIVILEGE_TYPE.CPC },
      { label: "Mobile Topup (TP)", value: PRIVILEGE_TYPE.TOPUP },
      { label: "Point Transfer (PTF)", value: PRIVILEGE_TYPE.EXCHANGE },
    ],
  });

  const privilegeRedeemLimit = ref([
    { label: "Limit/Cap", value: 1 },
    { label: "Unlimited", value: 2 },
  ]);

  const PrivilegeExpirationMode = ref([
    { label: "None", value: 1 },
    { label: "Period", value: 2 },
    { label: "Fixed Date", value: 3 },
    { label: "Use Inventory Serial Exp.", value: 4 },
  ]);

  const privilegeCouponCodeList = ref([
    // { label: 'None', value: 0 },
    { label: "External Code", value: 5 },
  ]);

  const PrivilegeExpRoundingMode = ref([
    { label: "None/As-is", value: 1 },
    { label: "Full Day", value: 2 },
  ]);

  const privilegeRedeemMode = ref([
    { label: "None", value: 1 },
    { label: "FEFO", value: 2 },
    { label: "FIFO", value: 3 },
  ]);

  const onSelectValidFromDate = () => {
    if (formData.validThrough.date) {
      const validThroughDate = new Date(
        resolveDateString(formData.validThrough.date)
      );

      const validFromDate = new Date(
        resolveDateString(formData.validFrom.date)
      );

      if (validFromDate > validThroughDate) {
        formData.validThrough.date = null;
        formData.validThrough.time = null;
      }
    }
    flatpickrDateConfig.minDate = formData.validFrom.date;
  };

  const onSelectValidFromTimePicker = () => {
    if (
      formData.validFrom.date == formData.validThrough.date &&
      formData.validFrom.time > formData.validThrough.time
    ) {
      formData.validThrough.time = null;
    }
  };

  const onOpenValidThroughTimePicker = () => {
    if (formData.validFrom.date == formData.validThrough.date) {
      flatpickrTimeConfig.minTime = formData.validFrom.time;
    }
  };

  const onSelectFixedDate = () => {
    flatpickrDateConfig.minDate = formData.fixedDate.date;
  };

  const onSelectFixedDateTime = () => {
    flatpickrTimeConfig.minTime = formData.fixedDate.time;
  };

  const onSelectExp = (e) => {
    switch (e) {
      case 1:
        break;
      case 2:
        break;
      default:
    }
  };

  const onSelectPrivilegeType = (privilegeType) => {
    // formData.RedeemMode = null;
  };

  const openAssignModal = () => {
    modalType.assignInventory = true;
    openModal();
  };

  const closeAssignModal = () => {
    modalType.assignInventory = false;
    closeModal();
  };

  const onSelectStore = () => {
    // ToDo
  };

  const onSelectInventory = () => {
    openAssignModal();
  };

  const onNumberInput = (ev, formDataValue) => {
    vm.$nextTick(() => {
      const inputNumber = ev.replace(/\D/g, "");
      formData[formDataValue] = inputNumber;
    });
  };

  const onSelectAssignInventory = (inventory) => {
    if (props.privilegeId) {
      fetchAssignEntryInventory.payload.Inventory_Id = inventory.inventory_id;
      fetchAssignEntryInventory.payload.Privilege_Id = formData.privilegeId;
      store
        .dispatch("api/apiRequest", fetchAssignEntryInventory)
        .then((response) => {})
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          fetchInfoDetail();
        });
    } else {
      privilegeSelect.value.inventory_entry.push(inventory.inventory_id);
    }
  };

  const fetchInfoDetail = () => {
    window.$loading(true);
    fetchDetail.payload.Privilege_Id = formData.privilegeId;

    store
      .dispatch("api/apiRequest", fetchDetail)
      .then((resp) => {
        const respData = resp.data.resp;

        localStorage.setItem("pv_PointRef", respData.point_ref);

        formData.isActive = respData.status == 1;
        formData.reference = respData.alt_reference;
        formData.privilegeType = respData.type;
        formData.nameEn = respData.name_en;
        formData.nameTh = respData.name_th;
        formData.subNameEn = respData.subname_en;
        formData.subNameTh = respData.subname_th;
        formData.detailEn = respData.desc_en;
        formData.detailTh = respData.desc_th;
        formData.ruleTh = respData.termsandconds_th;
        formData.ruleEn = respData.termsandconds_en;
        formData.RedeemLimit = respData.limit_type;
        formData.ExpirationMode = respData.exp_mode;
        formData.ExpYear = respData.exp_period_year;
        formData.ExpMonth = respData.exp_period_month;
        formData.ExpDay = respData.exp_period_day;
        formData.ExpHour = respData.exp_period_hour;
        formData.ExpMinute = respData.exp_period_minute;
        formData.IssueOverall = respData.privilege_limit.issue_overall;
        formData.IssuePerDay = respData.privilege_limit.issue_perday;
        formData.IssuePerMonth = respData.privilege_limit.issue_permonth;
        formData.IssuePerCustomer = respData.privilege_limit.issue_percustomer;
        formData.IssuePerCustomerDay =
          respData.privilege_limit.issue_percustomer_perday;
        formData.IssuePerCustomerMonth =
          respData.privilege_limit.issue_percustomer_permonth;
        formData.RedeemOverall = respData.privilege_limit.redeem_overall;
        formData.RedeemDay = respData.privilege_limit.redeem_perday;
        formData.RedeemMonth = respData.privilege_limit.redeem_permonth;
        formData.RedeemCustomer = respData.privilege_limit.redeem_percustomer;
        formData.RedeemCustomerDay =
          respData.privilege_limit.redeem_percustomer_perday;
        formData.RedeemCustomerMonth =
          respData.privilege_limit.redeem_percustomer_permonth;
        formData.ValueReference = respData.value_ref;
        formData.pointRef = respData.point_ref;
        formData.ReserveTimeOut = respData.reserve_timeout;
        formData.couponCodeType = respData.cpc_type;
        formData.redeemPerMin = respData.cpc_qty_per_issue;
        formData.validFrom.date = respData.valid_from
          ? resolveDate(respData.valid_from)
          : null;
        formData.validFrom.time = respData.valid_from
          ? resolveTime(respData.valid_from)
          : null;
        formData.validThrough.date = respData.valid_through
          ? resolveDate(respData.valid_through)
          : null;
        formData.validThrough.time = respData.valid_through
          ? resolveTime(respData.valid_through)
          : null;
        formData.fixedDate.date = respData.exp_period_fixeddate
          ? resolveDate(respData.exp_period_fixeddate)
          : null;
        formData.fixedDate.time = respData.exp_period_fixeddate
          ? resolveTime(respData.exp_period_fixeddate)
          : null;
        formData.ExpRoundingMode = respData.exp_rounding_mode;
        formData.assignInventoryList =
          respData.privilege_entry_mapping.length > 0
            ? respData.privilege_entry_mapping.map((o) => o.inventory_id)
            : [];
        formData.storeMapping = respData.store_mapping;
        privilegeSelect.value = {
          inventory_entry: formData.assignInventoryList,
        };

        vm.$nextTick(() => {
          if (formData.privilegeType == PRIVILEGE_TYPE.TOPUP) {
            try {
              vm.$refs.mobileTopup.setCarrierSelect(
                respData.carrier_flag || [],
                respData.topup_value || 0
              );
            } catch {}
          }
        });

        if (formData.privilegeType == PRIVILEGE_TYPE.EXCHANGE) {
          formData.ExchangeId = respData.exc_schemeid;
        }
      })
      .catch((err) => {
        openDefaultErrorModal();
      })
      .finally(() => {
        window.$loading(false);
        isEditData.value = false;
      });
  };

  const validatePrivilegeForm = () => {
    if (formData.privilegeType == PRIVILEGE_TYPE.TOPUP) {
      let topup = vm.$refs.mobileTopup.getCarrierSelect();
      if (!topup.carrierFlag) {
        openErrorModal("เกิดข้อผิดพลาด", "กรุณาเลือกเครือข่ายเติมเงิน");
        return true;
      }
      if (!topup.value) {
        openErrorModal("เกิดข้อผิดพลาด", "กรุณาเลือกราคาบัตรเติมเงิน");
        return true;
      }
    }
    return false;
  };

  let dataLocal = [];

  const manageFormFunc = (isExit = false) => {
    if (validatePrivilegeForm()) return;
    window.$loading(true);
    loading.btnSave = true;
    const payload = {
      Status: formData.isActive ? 1 : 2, // required
      Type: formData.privilegeType, // required
      CPC_Type:
        formData.privilegeType == PRIVILEGE_TYPE.CPC
          ? formData.couponCodeType
          : 0, // 0 = None , 5 = External Code //required
      Name_Th: formData.nameTh, // required
      Name_En: formData.nameEn, // required
      SubName_Th: formData.subNameTh,
      SubName_En: formData.subNameEn,
      Desc_Th: formData.detailTh,
      Desc_En: formData.detailEn,
      TermsAndCondsTh: formData.ruleTh,
      TermsAndCondsEn: formData.ruleEn,
      Value_Ref: parseInt(formData.ValueReference) || 0, // Default = 0
      Point_Ref: parseInt(formData.pointRef) || 0,
      Reserve_Timeout: parseInt(formData.ReserveTimeOut) || 0, // default = 300
      CPC_Qty_Per_Issue: formData.redeemPerMin || 1, // default = 1
      Redeem_Mode: formData.RedeemMode || 1,
      Remark: "",
      Issue_Overall: parseInt(formData.IssueOverall) || 0, // 0 = unlimited
      Issue_PerDay: parseInt(formData.IssuePerDay) || 0,
      Issue_PerCustomer: parseInt(formData.IssuePerCustomer) || 0,
      Issue_PerCustomer_PerDay: parseInt(formData.IssuePerCustomerDay) || 0,
      Issue_PerMonth: parseInt(formData.IssuePerMonth) || 0,
      Issue_PerCustomer_PerMonth: parseInt(formData.IssuePerCustomerMonth) || 0,
      Redeem_Overall: parseInt(formData.RedeemOverall) || 0,
      Redeem_PerDay: parseInt(formData.RedeemDay) || 0,
      Redeem_PerCustomer: parseInt(formData.RedeemCustomer) || 0,
      Redeem_PerCustomer_PerDay: parseInt(formData.RedeemCustomerDay) || 0,
      Redeem_PerMonth: parseInt(formData.RedeemMonth) || 0,
      Redeem_PerCustomer_PerMonth: parseInt(formData.RedeemCustomerMonth) || 0,
      Valid_From:
        formData.validFrom.date && formData.validFrom.time
          ? resolveDateObject(formData.validFrom)
          : null, // required
      Valid_Through:
        formData.validThrough.date && formData.validThrough.time
          ? resolveDateObject(formData.validThrough)
          : null, // required
      Exp_Mode:
        formData.privilegeType == PRIVILEGE_TYPE.REWARD ||
        formData.privilegeType == PRIVILEGE_TYPE.CPC
          ? checkExpMode(formData.privilegeType)
          : parseInt(formData.ExpirationMode), // required
      Exp_Rounding_Mode:
        formData.privilegeType == PRIVILEGE_TYPE.REWARD ||
        formData.privilegeType == PRIVILEGE_TYPE.CPC
          ? 1
          : parseInt(formData.ExpRoundingMode), // 1 = None/As-is | 2 = Full Day 00:00
      Exp_Period_Year: parseInt(formData.ExpYear) || 0,
      Exp_Period_Month: parseInt(formData.ExpMonth) || 0,
      Exp_Period_Day: parseInt(formData.ExpDay) || 0,
      Exp_Period_Hour: parseInt(formData.ExpHour) || 0,
      Exp_Period_Minute: parseInt(formData.ExpMinute) || 0,
      Exp_Period_FixedDate:
        formData.fixedDate.date && formData.fixedDate.time
          ? resolveDateObject(formData.fixedDate)
          : "2022-11-15 16:05:24.4457382", // required
      Carrier_Flag: null,
      Topup_Value: null,
      Store_Mappings: [],
      EXC_SchemeId: null, //privilegeType = 6
      Inventory_Mappings: [],
      Req_IdentityId: 1, // required
    };

    if (formData.privilegeType == PRIVILEGE_TYPE.TOPUP) {
      payload.Carrier_Flag = vm.$refs.mobileTopup.getCarrierSelect().carrierFlag;
      payload.Topup_Value = vm.$refs.mobileTopup.getCarrierSelect().value;
    }

    if (formData.privilegeType == PRIVILEGE_TYPE.EXCHANGE) {
      payload.EXC_SchemeId = formData.ExchangeId;
    }

    createForm.payload = payload;
    editForm.payload = payload;

    let payloadParam = {};

    if (props.privilegeId || props.isEdit) {
      editForm.payload.Privilege_Id = formData.privilegeId;

      payloadParam = editForm;
    } else {
      privilegeSelect.value.inventory_entry.map((o) => {
        createForm.payload.Inventory_Mappings.push({
          Inventory_Id: o,
        });
      });
      payloadParam = createForm;
    }

    store
      .dispatch("api/apiRequest", payloadParam)
      .then(async (resp) => {
        const respData = resp.data.resp;
        formData.privilegeId = respData.privilege_id;
        localStorage.setItem("pv_PointRef", respData.point_ref);

        dataLocal.push({
          exchangeType: respData.type,
          exchangeStepValue: formData.ExchangeStepValue,
          exchangeMinValue: formData.ExchangeMinValue,
          exChangePoint: respData.point_ref,
        });
        localStorage.setItem('dataLocalStorage',JSON.stringify(dataLocal));
        
        router
          .replace(
            `${router.currentRoute.path}?privilegeId=${formData.privilegeId}`
          )
          .catch(() => {});
        vm.$emit("onGetPrivilegeId", respData.privilege_id);
        await fetchInfoDetail();
        if (isExit == true)
          return router.push("/privilege/list").catch(() => {});
        await nextStep();
      })
      .catch((err) => {
        openDefaultErrorModal();
      })
      .finally(() => {
        window.$loading(false);
        loading.btnSave = false;
      });
  };

  const checkExpMode = (type) => {
    switch (type) {
      case PRIVILEGE_TYPE.REWARD:
        return 1;
      case PRIVILEGE_TYPE.CPC:
        return 4;
    }
  };

  const updatePointRefExchange = (number,type) => {
    if(type == 'pointRef'){
      vm.$emit('onUpdatePointRef',number)
    }
    else{
      vm.$emit('onUpdateValueRef',number)
    }
      
  }

  const onUpdatePointRef = (number) =>{
    formData.pointRef = number
  }

  const onUpdateValueRef = (number) =>{
    formData.ValueReference = number
  }

  const onSetSpinValueExchange = (carrier) => {
    formData.ExchangeStepValue = carrier.conversion_step;
    formData.ExchangeMinValue = carrier.min_transfer_from;

     dataLocal.push({
      exchangeType: formData.privilegeType,
      exchangeStepValue: formData.ExchangeStepValue,
      exchangeMinValue: formData.ExchangeMinValue,
      exChangePoint: formData.pointRef,
    });
    localStorage.setItem('dataLocalStorage',JSON.stringify(dataLocal));
  }

  const onSelectCarrierExchange = (carrier) => {
    formData.ExchangeId = carrier.schemeid;
    formData.ExchangeStepValue = carrier.conversion_step;
    formData.ExchangeMinValue = carrier.min_transfer_from;

    formData.pointRef = carrier.min_transfer_from;
    formData.ValueReference = 0;
  };

  const openWarningSaveData = () => {
    openWarningModal(
      "ต้องการบันทึกการเปลี่ยนแปลงหรือไม่",
      null,
      () => {
        manageFormFunc(true);
      },
      () => {
        router.push("/privilege/list").catch(() => {});
      }
    );
  };

  const onSubmitForm = () => {

    //check Minimum tansfer point
    if (formData.privilegeType == PRIVILEGE_TYPE.EXCHANGE){
      if(formData.pointRef < formData.ExchangeMinValue){
        openWarningModal(
          'Point Transfer',`Point Reference น้อยกว่าค่า Minimum ที่กำหนด (${formData.ExchangeMinValue} Point)`,
          null,null,null,'ปิด',false,true,
        );
        return false;
      }
    }

    if (isEditData.value == true) {
      manageFormFunc();
    } else {
      nextStep();
    }
  };

  const onBack = async () => {
    if (isEditData.value == true) {
      await openWarningSaveData();
    } else {
      router.push("/privilege/list").catch(() => {});
    }
  };

  const nextStep = () => {
    window.scrollToTop();
    vm.$emit("onNextStep");
  };

  const checkFormCreateOrEdit = () => {
    if (router.currentRoute.query.privilegeId) {
      vm.$emit(
        "onGetPrivilegeId",
        parseInt(router.currentRoute.query.privilegeId)
      );
    }
  };

  watch(
    () => [formData.ruleTh, formData.ruleEn],
    () => {
      window.$setAttrLoadingLazy();
    }
  );

  watch(
    formData,
    () => {
      isEditData.value = true;
    },
    { deep: true }
  );

  return {
    PRIVILEGE_TYPE,
    privilegeRedeemLimit,
    privilegeRedeemMode,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    PrivilegeExpirationMode,
    formData,
    optionData,
    modalType,
    privilegeCouponCodeList,
    PrivilegeExpRoundingMode,
    loading,
    privilegeSelect,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    onSelectExp,
    openAssignModal,
    closeAssignModal,
    onSubmitForm,
    onSelectStore,
    onSelectInventory,
    onNumberInput,
    onSelectFixedDate,
    onSelectFixedDateTime,
    onBack,
    onSelectAssignInventory,
    onSelectPrivilegeType,
    fetchInfoDetail,
    checkFormCreateOrEdit,
    onSelectCarrierExchange,
    onSetSpinValueExchange,
    updatePointRefExchange,
    onUpdatePointRef,
    onUpdateValueRef,
    dataLocal,
  };
}
